import React from 'react';


import Animation from "../animation/animation";
import Card from "../card/card";
import ContactFormRu from "../contact-form/contact-form-ru";
import Grid from "../grid/grid";
import GridLine from "../grid-line/grid-line";

import './services.scss';

import urbanVideo from '../../f/videos/urban.mp4';
import urbanCover from '../../f/img/urban.jpg';

import retailVideo from '../../f/videos/retail.mp4';
import retailPoster from '../../f/img/retail.png';

import sportVideo from '../../f/videos/sport.mp4';
import sportPoster from '../../f/img/sport.png';

import fmcgVideo from '../../f/videos/fmcg.mp4';
import fmcgPoster from '../../f/img/fmcg.png';

import industryVideo from '../../f/videos/industry.mp4';
import industryPoster from '../../f/img/industry.png';

import realVideo from '../../f/videos/real.mp4';
import realPoster from '../../f/img/real.jpg';

const ServicesRu = () => {
  return (
    <React.Fragment>
      <div className="services category-list">
        <div className="services-header">
          <h1 className="services-header__text">Компетенции</h1>

          <div className='services-header__link-list'>
            <a className='services-header__link' href='/competencies'>Что мы делаем</a>
            <div className='services-header__link active-link'>Для кого</div>
          </div>

          <Animation header="aйдентика, архитектура, веб, видео, графдизайн, городская среда, иллюстрации, интерьеры, интерфейсы, книги, логотипы, мобильные приложения, моушн-дизайн, навигация, паттерны, презентации, промдизайн, реклама, шрифты, экстерьеры" />

          <div className="als-text-container">
            <p className="services__text">
              Для каждой отрасли&nbsp;&mdash; свой набор решений, проверенный сотнями проектов: от&nbsp;стратегии и&nbsp;брендинга до&nbsp;навигации и&nbsp;архитектуры.
            </p>
          </div>
        </div>
        <div className="services-main">
          <Grid>
            <GridLine>
              <Card
                url="/competencies/target/urban"
                type="video"
                previewContent={urbanVideo}
                poster={urbanCover}
                title="Дизайн для городов"
                description="Дизайн, который делает города узнаваемыми и&nbsp;удобными. От&nbsp;стратегии и&nbsp;брендинга до&nbsp;навигации и&nbsp;архитектуры."
              />
              <Card
                url="/competencies/target/retail"
                type="video"
                previewContent={retailVideo}
                poster={retailPoster}
                title="Дизайн для торговли"
                description="Помогаем брендам говорить о&nbsp;себе ярко и&nbsp;убедительно в&nbsp;любой среде и&nbsp;коммуникации: в&nbsp;онлайне, в&nbsp;печати, на&nbsp;фасаде или магазинной полке."
              />
              <Card
                url="/competencies/target/sport"
                type="video"
                previewContent={sportVideo}
                poster={sportPoster}
                title="Дизайн для спорта"
                description="Вдохновляем спортсменов на&nbsp;победы и&nbsp;будим в&nbsp;болельщиках скрытые эмоции. Создаем командные бренды, проектируем спортивные пространства и&nbsp;формируем целые визуальные системы."
              />
              <Card
                url="/competencies/target/fmcg"
                type="video"
                previewContent={fmcgVideo}
                poster={fmcgPoster}
                title="Дизайн товаров повседневного спроса"
                description="Создаем образ товара, который замечают на&nbsp;полках, внимательно изучают и&nbsp;в&nbsp;итоге покупают. Каждый день."
              />
              <Card
                url="/competencies/target/industry"
                type="video"
                previewContent={industryVideo}
                poster={industryPoster}
                title="Дизайн для промышленности"
                description="Мы&nbsp;помогаем мощным промышленным предприятиям становиться ближе к&nbsp;людям: ярко представляем их&nbsp;деятельность и&nbsp;продукцию, улучшаем условия для работы сотрудников, решаем внутренние и&nbsp;внешние коммуникационные задачи."
              />
              <Card
                url="/competencies/target/real-estate"
                type="video"
                previewContent={realVideo}
                poster={realPoster}
                title="Дизайн для недвижимости"
                description="Мы&nbsp;с&nbsp;удовольствием работаем вместе с&nbsp;девелоперами над объектами недвижимости: оформляем фасады, придумываем арт-объекты, создаем интерьеры и&nbsp;облагораживаем территории. С&nbsp;нашей помощью каждый проект обретает индивидуальность и&nbsp;проявляет свой особый характер."
              />
            </GridLine>
          </Grid>
        </div>
        <ContactFormRu formId="другое" />
      </div>
    </React.Fragment>
  );
}

export default ServicesRu;
